import { Container, Table, TableBody, TableCell, Paper, TablePagination, FormControl, InputLabel, Chip, TableContainer, TableHead, TableRow, Typography, Card, CardContent, Box, Grid, Button, TextField, Select, MenuItem, Autocomplete } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

import User from '../../models/user';
import Orders from "../../collections/orders";
import UserSupportHistoryComponent from './UserSupportHistory';
import Account from '../../models/account';
import TagInput from '../common/TagInput';

const UserDetails = (props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [orders, setOrders] = useState([]);
    const [totalOrders, setTotalOrders] = useState(0);
    const [dateRange, setDateRange] = useState([null, null]);
    const [financialStatus, setFinancialStatus] = useState('');
    const [user, setUser] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const user = new User();
            const res = await user.getUserById(id);
            setUser(res.data);
            const customerOrders = new Orders();
            await customerOrders.fetchOrdersByUser(page + 1, rowsPerPage, id, dayjs(dateRange[0]).isValid() ? dayjs(dateRange[0]).format("YYYY-MM-DD") : null, dayjs(dateRange[1]).isValid() ? dayjs(dateRange[1]).format("YYYY-MM-DD") : null, financialStatus || null);
            setOrders(customerOrders.items);
            setTotalOrders(customerOrders.total);
            props.setPageTitle(`Danh sách đơn hàng của ${res.data.name}`);
            
            // Fetch current user (staff) from localStorage
            try {
                const userData = JSON.parse(localStorage.getItem('user'));
                if (userData) {
                    setCurrentUser(userData);
                }
            } catch (error) {
                console.error('Error getting current user:', error);
            }
        }
        fetchData();
    }, [page, rowsPerPage, dateRange, financialStatus])
    console.log(user);
    const formatDate = (dateString) => {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return new Date(dateString).toLocaleDateString('vi-VN', options);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDateChange = (index, newValue) => {
        const newDateRange = [...dateRange];
        newDateRange[index] = newValue;
        setDateRange(newDateRange);
    };
    const handleEditToggle = () => setIsEditing(!isEditing);
    const handleCancelEdit = () => {
        setIsEditing(false);
    };

    const handleConfirmEdit = async () => {
        const updatedUser = new User({
            id: user.id,
            name: user.name,
            phone_number: user.phone_number,
            backup_phone_number: user.backup_phone_number,
            email: user.email,
            address: user.address,
            note: user.note,
            tags: user.tags,
        })
        try {
            const res = await updatedUser.updateUser();
            if (res.success) {
                toast.success(res.messenge, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                })
                setIsEditing(false);
            }
        }
        catch (error) {
            toast.error("Đã xảy ra lỗi, vui lòng thử lại", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }
    return (
        <Container sx={{ mt: 3 }}>
            <Card variant="outlined" sx={{ mb: 3, p: 3, bgcolor: '#f8f9fa' }}>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={12}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            borderBottom: '2px solid #1976d2',
                            pb: 1,
                            mb: 3
                        }}>
                            <Typography variant="h6" gutterBottom color="primary">
                                Thông tin khách hàng
                            </Typography>
                            <Box sx={{ ml: 'auto' }}>
                                {!isEditing ? (
                                    <Button variant="contained" color="primary" onClick={handleEditToggle}>
                                        Chỉnh sửa thông tin khách hàng
                                    </Button>
                                ) : (
                                    <Box sx={{ display: 'inline-flex', ml: 'auto' }}>
                                        <Button variant="contained" color="error" sx={{ mr: 1 }} onClick={handleCancelEdit}>
                                            Hủy chỉnh sửa
                                        </Button>
                                        <Button variant="contained" color="primary" onClick={handleConfirmEdit}>
                                            Lưu chỉnh sửa
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                {isEditing ? (
                                    <>
                                        <TextField
                                            fullWidth
                                            label="Tên khách hàng"
                                            variant="outlined"
                                            value={user?.name || ''}
                                            onChange={(e) => setUser({ ...user, name: e.target.value })}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Email"
                                            variant="outlined"
                                            value={user?.email || ''}
                                            onChange={(e) => setUser({ ...user, email: e.target.value })}
                                            sx={{ mt: 2 }}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <Typography variant="body1">
                                            <strong>Tên khách hàng:</strong> {user?.name || 'N/A'}
                                        </Typography>
                                        <Typography variant="body1">
                                            <strong>Email:</strong> {user?.email || 'N/A'}
                                        </Typography>
                                    </>
                                )}
                            </Grid>

                            <Grid item xs={12} md={6}>
                                {isEditing ? (
                                    <>
                                        <TextField
                                            fullWidth
                                            label="Số điện thoại"
                                            variant="outlined"
                                            value={user?.phone_number || ''}
                                            onChange={(e) => setUser({ ...user, phone_number: e.target.value })}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Số điện thoại dự phòng"
                                            variant="outlined"
                                            value={user?.backup_phone_number || ''}
                                            onChange={(e) => setUser({ ...user, backup_phone_number: e.target.value })}
                                            sx={{ mt: 2 }}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Địa chỉ"
                                            variant="outlined"
                                            value={user?.address || ''}
                                            onChange={(e) => setUser({ ...user, address: e.target.value })}
                                            sx={{ mt: 2 }}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <Typography variant="body1">
                                            <strong>Số điện thoại:</strong> {user?.phone_number || 'N/A'}
                                        </Typography>
                                        <Typography variant="body1">
                                            <strong>Số điện thoại dự phòng:</strong> {user?.backup_phone_number || 'N/A'}
                                        </Typography>
                                        <Typography variant="body1">
                                            <strong>Địa chỉ:</strong> {user?.address || 'N/A'}
                                        </Typography>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item xs={12}>
                                {isEditing ? (
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={3}
                                        label="Ghi chú"
                                        variant="outlined"
                                        value={user?.note || ''}
                                        onChange={(e) => setUser({ ...user, note: e.target.value })}
                                    />
                                ) : (
                                    <Typography variant="body1">
                                        <strong>Ghi chú:</strong> {user?.note || 'N/A'}
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item xs={12}>
                                {isEditing ? (
                                    <TagInput
                                        value={user?.tags || ''}
                                        onChange={(newTags) => setUser({ ...user, tags: newTags })}
                                        label="Tags"
                                        placeholder="Nhập tag và nhấn Enter (VD: VIP, Wholesale)"
                                    />
                                ) : (
                                    <Box>
                                        <Typography variant="body1" component="span">
                                            <strong>Tags:</strong>{' '}
                                        </Typography>
                                        {user?.tags ? (
                                            user.tags.split(',').map((tag, index) => (
                                                <Chip
                                                    key={index}
                                                    label={tag.trim()}
                                                    size="small"
                                                    color="primary"
                                                    variant="outlined"
                                                    sx={{ mr: 0.5, mb: 0.5 }}
                                                />
                                            ))
                                        ) : (
                                            <Typography variant="body1" component="span">
                                                N/A
                                            </Typography>
                                        )}
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Grid >
                </Grid >
            </Card>
            
            {/* User Support History Section */}
            <UserSupportHistoryComponent 
                userId={id} 
                currentUser={currentUser}
            />
            
            <Typography variant="subtitle1" sx={{ mb: 1, mt: 3 }}>
                Danh sách đơn hàng của {user.name}
            </Typography>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Lọc kết quả:
            </Typography>
            <Grid container spacing={4} sx={{ mb: 2 }}>
                <Grid item xs={4}>
                    <DatePicker
                        label="Từ ngày"
                        value={dateRange[0]}
                        onChange={(newValue) => {
                            handleDateChange(0, newValue);
                            setPage(0);
                        }}
                        renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} />}
                        inputFormat="DD/MM/YYYY"
                        sx={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <DatePicker
                        label="Đến ngày"
                        value={dateRange[1]}
                        onChange={(newValue) => {
                            handleDateChange(1, newValue);
                            setPage(0);
                        }}
                        renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} />}
                        inputFormat="DD/MM/YYYY"
                        sx={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <FormControl variant="outlined" sx={{ width: '100%' }}>
                        <InputLabel id="financial-status-label" shrink>Trạng thái thanh toán</InputLabel>
                        <Select
                            labelId="financial-status-label"
                            value={financialStatus}
                            onChange={(e) => {
                                setFinancialStatus(e.target.value);
                                setPage(0);
                            }}
                            label="Trạng thái thanh toán"
                            displayEmpty
                        >
                            <MenuItem value="">Tất cả</MenuItem>
                            <MenuItem value="PAID">Đã thanh toán</MenuItem>
                            <MenuItem value="SKIPPED">Bỏ qua</MenuItem>
                            <MenuItem value="UNPAID">Chưa thanh toán</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Ngày tạo</TableCell>
                            <TableCell>Mã Đơn Hàng</TableCell>
                            <TableCell>Địa chỉ</TableCell>
                            <TableCell>Phí Ship</TableCell>
                            <TableCell>Loại đơn hàng</TableCell>
                            <TableCell>Trạng thái</TableCell>
                            <TableCell>Thanh toán</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {orders.map((order, index) => (
                            <TableRow
                                key={index}
                                onClick={() => navigate(`/orders/${order.id}`)}
                                sx={{
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5',
                                    },
                                }}
                            >
                                <TableCell>{formatDate(order.created_at)}</TableCell>
                                <TableCell>{order.name}</TableCell>
                                <TableCell>{order.shipping_address}</TableCell>
                                <TableCell>{order.shipping_price}</TableCell>
                                <TableCell>
                                    {order.order_type === 'INSTANT_ORDER' ? (
                                        <Chip label="Đơn lẻ" sx={{ backgroundColor: '#e3f2fd', color: '#1976d2' }} />
                                    ) : order.order_type === 'MONTHLY_PACKAGE_ORDER' ? (
                                        <Chip label="Đơn tháng" sx={{ backgroundColor: '#f3e5f5', color: '#7b1fa2' }} />
                                    ) : (
                                        <Chip label="N/A" />
                                    )}
                                </TableCell>
                                <TableCell>
                                    {order.status === 'OPEN' ? (
                                        <Chip label="Mới" sx={{ backgroundColor: '#fff3e0', color: '#e65100' }} />
                                    ) : order.status === 'SENT_INVOICE' ? (
                                        <Chip label="Đã gửi hóa đơn" sx={{ backgroundColor: '#e8f5e9', color: '#2e7d32' }} />
                                    ) : (
                                        <Chip label={order.status} sx={{ backgroundColor: '#f5f5f5', color: '#757575' }} />
                                    )}
                                </TableCell>
                                <TableCell>
                                    {order.financial_status === 'UNPAID' ? (
                                        <Chip label="Chưa thanh toán" sx={{ backgroundColor: '#ffebee', color: '#c62828' }} />
                                    ) : order.financial_status === 'PAID' ? (
                                        <Chip label="Đã thanh toán" sx={{ backgroundColor: '#e8f5e9', color: '#2e7d32' }} />
                                    ) : order.financial_status === 'SKIPPED' ? (
                                        <Chip label="Bỏ qua" sx={{ backgroundColor: '#f5f5f5', color: '#757575' }} />
                                    ) : null}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={totalOrders}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Số hàng mỗi trang"
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} của ${count}`}
                />
            </TableContainer>
        </Container>
    )
}

export default UserDetails;